import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";

document.addEventListener("DOMContentLoaded", function () {
  var elem = document.querySelector(".gallery-grid");
  imagesLoaded(elem, function () {
    window.msnry = new Masonry(elem, {
      itemSelector: ".gallery-grid-item",
      columnWidth: ".gallery-grid-item",
      percentPosition: true,
    });
  });

  var dataSource = [];
  var gridItems = document.getElementsByClassName("gallery-grid-item");
  for (var i = 0; i < gridItems.length; i++) {
    (function (index) {
      gridItems[i].onclick = function () {
        gtag("event", "openImageGallery", {
          index,
        });
        lightbox.loadAndOpen(index);
      };
    })(i);
    var img = gridItems[i].children[0];
    var src = img.src.replace("376w", "large");
    var width = img.dataset.width;
    var height = img.dataset.height;
    dataSource.push({ src, width, height });
  }

  const options = {
    dataSource: dataSource,
    showHideAnimationType: "none",
    pswpModule: () => import("photoswipe"),
  };

  window.lightbox = new PhotoSwipeLightbox(options);
  window.lightbox.init();
});
